@if (showGhostElement) {
  <div class="mt-4">
    <div
      class="skeleton-box-card"
      role="status"
      aria-live="polite"
      [attr.aria-label]="'Loading meeting types'"
    >
      <div class="row" role="list" [attr.aria-label]="'Loading meeting type options'">
        @for (ghostElement of slotGhostElements; track $index) {
          <div class="col-md-6" role="listitem">
            <div
              class="d-flex stats-card shadow"
              role="presentation"
              [attr.aria-hidden]="true"
            >
              <div class="skeleton-animation w-100 d-flex justify-content-center align-items-start gap-3">
                <div>
                  <div class="bar bar-3"></div>
                </div>
                <div class="w-100 gap-3 d-flex flex-column">
                  <div class="bar bar-1"></div>
                  <div class="bar bar-2"></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (meetingTypes?.length > 0) {
  <form #storeForm="ngForm" role="form" [attr.aria-label]="'Meeting type selection'">
    <div
      class="row cbsw-meeting-type-selection-step"
      role="region"
      [attr.aria-label]="'Meeting type selection options'"
    >
      <div class="col-md-12 cbsw-meeting-type-header">
        <div role="heading" aria-level="2">
          <app-csw-text
            customClass="step-element-title fw-600"
            [text]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_WHERE_SHOULD_THE_MEETING_TAKE_PLACE, type: 'template' }) | translation: 'template_content': lang) | calioSafe: 'html'"
          />
        </div>
      </div>

      @for (meetingType of meetingTypes; track meetingType.id) {
        <div
          class="mt-3 col-md-6 cursor-pointer cbsw-meeting-type-card"
          (keydown.enter)="onMeetingTypeChange(meetingType.id)"
          (keydown.space)="onMeetingTypeChange(meetingType.id)"
        >
          <app-info-card
            [showCardBorder]="true"
            [showShadow]="false"
            [showBody]="true"
            [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
            [isSelected]="selectedMeetingTypeId === meetingType.id"
          >
            <div
              cardBody
              (click)="onMeetingTypeChange(meetingType.id)"
              (keydown.enter)="onMeetingTypeChange(meetingType.id)"
              (keydown.space)="onMeetingTypeChange(meetingType.id); $event.preventDefault();"
              [attr.aria-label]="'Meeting type:' + (widgetTemplate?.titleTemplate | translation: 'template_content': lang)"
              role="button"
              tabindex="0"
              [attr.aria-label]="'Meeting type:' + (widgetTemplate?.titleTemplate | translation: 'template_content': lang)"
              [attr.aria-pressed]="selectedMeetingTypeId === meetingType.id"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div
                    class="avatar"
                    role="img"
                    [attr.aria-label]="(widgetTemplate?.titleTemplate | translation: 'template_content': lang) + ' meeting type icon'"
                  >
                    @if (meetingType.id === meetingTypeId.STORE) {
                      <img src="{{ imagePath }}/images/meetings/store.svg" class="meeting_type_id_1" width="26px" alt="Store meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.ZOOM) {
                      <img src="{{ imagePath }}/images/meetings/zoom.svg" class="meeting_type_id_2" width="26px" alt="Zoom meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.PHONE) {
                      <img src="{{ imagePath }}/images/meetings/phone.svg" class="meeting_type_id_4" width="26px" alt="Phone meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.CUSTOMER) {
                      <img src="{{ imagePath }}/images/meetings/customer.svg" class="meeting_type_id_5" width="26px" alt="Customer location meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.UNBLU) {
                      <img src="{{ imagePath }}/images/meetings/unblu.svg" class="meeting_type_id_6" width="26px" alt="Unblu meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.MICROSOFT_TEAMS) {
                      <img src="{{ imagePath }}/images/meetings/teams.svg" class="meeting_type_id_7" width="26px" alt="Teams meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.GOOGLE_MEET) {
                      <img src="{{ imagePath }}/images/meetings/meet.svg" class="meeting_type_id_8" width="26px" alt="Google Meet meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.GOTO_MEETING) {
                      <img src="{{ imagePath }}/images/meetings/gotomeeting.png" class="meeting_type_id_9" width="26px" alt="GoToMeeting meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.WEBEX) {
                      <img src="{{ imagePath }}/images/meetings/webex.png" class="meeting_type_id_10" width="26px" alt="Webex meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.WILL_CALL_YOU) {
                      <img src="{{ imagePath }}/images/meetings/phone.svg" class="meeting_type_id_11" width="26px" alt="Phone meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.METAVERSE) {
                      <img src="{{ imagePath }}/images/meetings/metaverse.svg" class="meeting_type_id_13" width="26px" alt="Metaverse meeting icon" />
                    } @else if (meetingType.id === meetingTypeId.KMEET) {
                      <img src="{{ imagePath }}/images/meetings/kmeet.png" class="meeting_type_id_15" width="26px" alt="kMeet meeting icon" />
                    }
                  </div>
                  @if ((bookingService.widgetTemplates | calioMeetingTemplate: {
                    id: meetingType.id,
                    type: 'meeting_template'
                    }); as widgetTemplate) {
                    <div class="ps-2 cbw-meeting-type-title">
                      <div>
                        <app-csw-text
                          [text]="(widgetTemplate.titleTemplate | translation: 'template_content': lang) | calioSafe: 'html'"
                          [attr.aria-label]="'Meeting type: ' + (widgetTemplate?.titleTemplate | translation: 'template_content': lang)"
                        />
                      </div>
                      <div
                        class="cbw-description cbw-meeting-type-description"
                        [innerHTML]="(widgetTemplate.descTemplate | translation: 'template_content': lang) | calioSafe: 'html'"
                        [attr.aria-label]="'Description: ' + (widgetTemplate?.descTemplate | translation: 'template_content': lang)"
                      >
                      </div>
                    </div>
                  }
                </div>
                <div class="next-arrow-container">
                  @if (selectedMeetingTypeId === meetingType.id) {
                    <span
                      type="button"
                      (click)="next()"
                      [attr.aria-label]="'Continue with ' + (widgetTemplate?.titleTemplate | translation: 'template_content': lang)"
                    >
                      <div class="next-button-wrapper">
                        <img
                          [src]="imagePath + '/images/next_icon_widget.svg'"
                          width="26px"
                          alt="Selected - Continue"
                          role="presentation"
                          aria-hidden="true"
                        >
                      </div>
                    </span>
                  }
                </div>
              </div>
            </div>
          </app-info-card>
        </div>
      }

      @if (showMeetingTypeSelectionRequiredError) {
        <div
          class="cbsw-meeting-type-selection-setp-error cbsw-global-step-error"
          role="alert"
          aria-live="assertive"
          [attr.aria-invalid]="true"
        >
          <div class="text-danger">
            <div>{{ 'error_messages.select_one_option' | translate }}</div>
          </div>
        </div>
      }
    </div>
    <div
      class="d-flex justify-content-end mt-4 cbw-custom-navigation"
      role="navigation"
      [attr.aria-label]="'Meeting type selection navigation'"
    >
      @if (bookingService.isBeforeQuestionsMode()) {
        <div class="me-2">
          <app-button
            id="{{ 'meeting-type-previous-btn' }}"
            (clickEvent)="previous()"
            (keydown.enter)="previous()"
            (keydown.space)="previous(); $event.preventDefault();"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            role="button"
            [attr.aria-label]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: 'template' }) | translation: 'template_content': lang) + ' - Go back to previous step'"
            tabindex="0"
          >
            <span
              class="custom-button-icon back"
              role="presentation"
              aria-hidden="true"
            ></span>
            {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: 'template' }) | translation: 'template_content': lang) }}
          </app-button>
        </div>
      }
      <div>
        <app-button
          id="{{ 'meeting-type-selection-next-btn' }}"
          (clickEvent)="next()"
          (keydown.enter)="next()"
          (keydown.space)="next(); $event.preventDefault();"
          [fontColor]="widgetService?.widgetConf?.button_font_color"
          [backgroundColor]="widgetService?.widgetConf?.button_background_color"
          role="button"
          [attr.aria-label]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_NEXT_BUTTON, type: 'template' }) | translation: 'template_content': lang) + ' - Continue to next step'"
          [attr.aria-disabled]="!storeForm.valid"
          tabindex="0"
        >
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_NEXT_BUTTON, type: 'template' }) | translation: 'template_content': lang) }}
          <span
            class="custom-button-icon next"
            role="presentation"
            aria-hidden="true"
          ></span>
        </app-button>
      </div>
    </div>
  </form>
}
